module.exports = require("core-js-pure/stable/object/define-property");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/object/define-property.js
// module id = 223
// module chunks = 0 1